import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Tabs, PageHeader } from '@airclou/ui'
import {
  OverviewTab,
  SubscriptionTab,
  InvoicesTab,
  PaymentMethodsTab,
  // UsageTab, -- hidden, see the tabs list
  ReportsTab,
} from './tabs'

export function BillingOverviewPage() {
  const navigate = useNavigate()
  const { t } = useTranslation('dashboard')
  const { tab } = useParams<{ tab?: string }>()
  const [activeTab, setActiveTab] = useState(tab || 'overview')

  const tabs = [
    {
      id: 'overview',
      label: t('billing.overview'),
      content: <OverviewTab />,
    },
    {
      id: 'subscription',
      label: t('billing.subscription'),
      content: <SubscriptionTab />,
    },
    {
      id: 'invoices',
      label: t('billing.invoices'),
      content: <InvoicesTab />,
    },
    {
      id: 'payment-methods',
      label: t('billing.paymentMethods'),
      content: <PaymentMethodsTab />,
    },
    // Usage tab hidden 2026-10-05: UsageTab renders hardcoded sample figures,
    // not this organization's usage. Restore once real usage counts exist
    // (docs/plans/ai-allowance-and-seat-caps-plan.md).
    // {
    //   id: 'usage',
    //   label: t('billing.usage'),
    //   content: <UsageTab />,
    // },
    {
      id: 'reports',
      label: t('billing.reports'),
      content: <ReportsTab />,
    },
  ]

  // Sync tab with URL
  useEffect(() => {
    const validTabs = tabs.map(t => t.id)
    const urlTab = tab || 'overview'

    if (!validTabs.includes(urlTab)) {
      navigate('/billing', { replace: true })
      return
    }

    if (urlTab !== activeTab) {
      setActiveTab(urlTab)
    }
  }, [tab])

  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab)
    if (newTab === 'overview') {
      navigate('/billing')
    } else {
      navigate(`/billing/${newTab}`)
    }
  }

  return (
    <div className="space-y-6">
      <PageHeader title={t('billing.title')} description={t('billing.subtitle')} />

      {/* Tabs */}
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </div>
  )
}
